/* tslint:disable */
/* eslint-disable */
/**
 * seller
 * アグリノート米市場 Seller API
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: mazhulin.d@water-cell.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 * 特別条件マスタ
 * @export
 * @interface SpecialConditionRead
 */
export interface SpecialConditionRead {
  /**
   * ID
   * @type {number}
   * @memberof SpecialConditionRead
   */
  readonly id: number
  /**
   * レコードのバージョン番号
   * @type {number}
   * @memberof SpecialConditionRead
   */
  readonly versionNumber: number
  /**
   * ステータス（true: 有効、false: 無効）
   * @type {boolean}
   * @memberof SpecialConditionRead
   */
  isActive: boolean
  /**
   * 特別条件名
   * @type {string}
   * @memberof SpecialConditionRead
   */
  name: string
  /**
   * 売るぞう表示テキスト
   * @type {string}
   * @memberof SpecialConditionRead
   */
  displayText: string
}

export function SpecialConditionReadFromJSON(json: any): SpecialConditionRead {
  return SpecialConditionReadFromJSONTyped(json, false)
}

export function SpecialConditionReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialConditionRead {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    versionNumber: json['version_number'],
    isActive: json['is_active'],
    name: json['name'],
    displayText: json['display_text'],
  }
}

export function SpecialConditionReadToJSON(value?: SpecialConditionRead | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    is_active: value.isActive,
    name: value.name,
    display_text: value.displayText,
  }
}
